// // // src/components/dashboard/LeaderboardTab.jsx
// // import React, { useState, useEffect, useMemo, useRef } from 'react';
// // import { Globe, Search, RefreshCw, FileText, Trophy } from 'lucide-react';
// // import axios from 'axios';
// // import { useOutletContext, useNavigate } from 'react-router-dom';
// // import PerformerDetailModal from './modals/PerformerDetailModal';
// // import './OverviewTab.css';
// // import { Box, TextField, MenuItem } from "@mui/material";
// // import SearchIcon from "@mui/icons-material/Search";

// // const rowsPerPage = 10;

// // export default function LeaderboardTab() {
// //   const { userRole } = useOutletContext();
// //   const navigate = useNavigate();
// //   const [data, setData] = useState([]);
// //   const [exams, setExams] = useState([]);
// //   const [departments, setDepartments] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [isRefreshing, setIsRefreshing] = useState(false);
// //   const [searchQuery, setSearchQuery] = useState('');
// //   const [selectedDept, setSelectedDept] = useState('all');
// //   const [selectedExam, setSelectedExam] = useState('all');
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [hasMore, setHasMore] = useState(false);
// //   const [totalItems, setTotalItems] = useState(0);
// //   const [modalOpen, setModalOpen] = useState(false);
// //   const [selectedPerformer, setSelectedPerformer] = useState(null);
// //   const [estimatedTotalPages, setEstimatedTotalPages] = useState(1);

// //   const previousFilters = useRef({ dept: 'all', exam: 'all' });

// //   // ================= FETCH DATA =================
// //   const fetchData = async () => {
// //     console.log('🚀 fetchData called for leaderboard', {
// //       userRole,
// //       currentPage,
// //       selectedDept,
// //       selectedExam,
// //     });

// //     if (!userRole) {
// //       console.warn('⛔ userRole not ready, skipping fetch');
// //       return;
// //     }

// //     if (isRefreshing) {
// //       console.warn('⛔ Already refreshing, skipping fetch');
// //       return;
// //     }

// //     setIsRefreshing(true);
// //     setLoading(true);

// //     try {
// //       const endpoint = '/managerdashboard/leaderboard/';

// //       const params = {
// //         page: currentPage,
// //         page_size: rowsPerPage,
// //       };

// //       if (selectedDept !== 'all') params.dept = selectedDept;
// //       if (selectedExam !== 'all') params.exam = selectedExam;

// //       console.log('📡 API REQUEST Leaderboard:', endpoint, params);

// //       const [lbRes, examRes, deptRes] = await Promise.all([
// //         axios.get(endpoint, { params }),
// //         axios.get('/managerdashboard/exam-titles/')
// //           .then(res => res.data)
// //           .catch(err => {
// //             console.error('Error fetching exams:', err);
// //             return { exams: [] };
// //           }),
// //         axios.get('/managerdashboard/all-departments/')
// //           .then(res => res.data)
// //           .catch(err => {
// //             console.error('Error fetching departments:', err);
// //             return { departments: [] };
// //           })
// //       ]);

// //       console.log('✅ API RESPONSE Leaderboard:', lbRes.data);

// //       const responseData = lbRes.data || {};
// //       const fetchedData = Array.isArray(responseData.data) ? responseData.data : [];

// //       setData(fetchedData);

// //       // Set has_more flag
// //       const hasMoreFlag = responseData.pagination?.has_more || false;
// //       setHasMore(hasMoreFlag);

// //       // Estimate total items and pages
// //       if (responseData.pagination?.total) {
// //         // If API returns total, use it
// //         const total = responseData.pagination.total;
// //         setTotalItems(total);
// //         setEstimatedTotalPages(Math.ceil(total / rowsPerPage));
// //       } else {
// //         // Otherwise estimate based on current page and has_more
// //         if (hasMoreFlag) {
// //           // If there's more, at least current page + 1 pages
// //           setEstimatedTotalPages(currentPage + 1);
// //           setTotalItems((currentPage * rowsPerPage) + 1);
// //         } else {
// //           // No more pages, so this is the last page
// //           setEstimatedTotalPages(currentPage);
// //           setTotalItems((currentPage - 1) * rowsPerPage + fetchedData.length);
// //         }
// //       }

// //       setExams(Array.isArray(examRes.exams) ? examRes.exams : []);
// //       setDepartments(Array.isArray(deptRes.departments) ? deptRes.departments : []);

// //     } catch (err) {
// //       console.error('❌ Error loading leaderboard:', err);
// //       console.error('Error details:', err.response?.data || err.message);
// //       setData([]);
// //       setHasMore(false);
// //       setTotalItems(0);
// //       setEstimatedTotalPages(1);
// //     } finally {
// //       setLoading(false);
// //       setIsRefreshing(false);
// //       console.log('🏁 fetchData completed for leaderboard');
// //     }
// //   };

// //   // ================= FILTERED DATA =================
// //   const filteredData = useMemo(() => {
// //     if (!Array.isArray(data)) return [];

// //     if (searchQuery.trim()) {
// //       const query = searchQuery.toLowerCase().trim();
// //       return data.filter((item) => {
// //         return (
// //           (item.name || '').toLowerCase().includes(query) ||
// //           (item.dept || '').toLowerCase().includes(query) ||
// //           (item.exam || '').toLowerCase().includes(query) ||
// //           String(item.score || '').includes(query) ||
// //           String(item.rank || '').includes(query)
// //         );
// //       });
// //     }

// //     return data;
// //   }, [data, searchQuery]);

// //   // ================= EFFECTS =================
// //   useEffect(() => {
// //     fetchData();
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [currentPage, selectedDept, selectedExam, userRole]);

// //   useEffect(() => {
// //     if (
// //       selectedDept !== previousFilters.current.dept ||
// //       selectedExam !== previousFilters.current.exam
// //     ) {
// //       setCurrentPage(1);
// //     }
// //     previousFilters.current = { dept: selectedDept, exam: selectedExam };
// //   }, [selectedDept, selectedExam]);

// //   // ================= HANDLERS =================
// //   const handleRefresh = () => {
// //     setSelectedDept('all');
// //     setSelectedExam('all');
// //     setSearchQuery('');
// //     setCurrentPage(1);
// //     fetchData();
// //   };

// //   const handleRowClick = (performer) => {
// //     setSelectedPerformer(performer);
// //     setModalOpen(true);
// //   };

// //   const handlePageChange = (newPage) => {
// //     setCurrentPage(newPage);
// //   };

// //   // Generate page numbers for pagination
// //   const getPageNumbers = () => {
// //     const pages = [];
// //     const maxPagesToShow = 5;

// //     if (estimatedTotalPages <= maxPagesToShow) {
// //       for (let i = 1; i <= estimatedTotalPages; i++) {
// //         pages.push(i);
// //       }
// //     } else {
// //       let start = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
// //       let end = Math.min(estimatedTotalPages, start + maxPagesToShow - 1);

// //       if (end - start + 1 < maxPagesToShow) {
// //         start = end - maxPagesToShow + 1;
// //       }

// //       for (let i = start; i <= end; i++) {
// //         pages.push(i);
// //       }
// //     }

// //     return pages;
// //   };

// //   const pageNumbers = getPageNumbers();

// //   const getShowingRange = () => {
// //     if (filteredData.length === 0 || totalItems === 0) return '';

// //     const start = (currentPage - 1) * rowsPerPage + 1;
// //     const end = start + filteredData.length - 1;

// //     return `Showing ${start} to ${end} of ${totalItems} entries`;
// //   };

// //   const handleGoBack = () => {
// //     if (userRole === '8') navigate('/managers/dashboard');
// //     else if (userRole === '9') navigate('/hr/dashboard');
// //     else navigate('/dashboard');
// //   };


// //   // ================= RENDER =================
// //   return (
// //     <>
// //       <div className="pd-overview-container">
// //         {/* HEADER */}
// //         <div className="pd-header">
// //           <div className="pd-title-section">
// //             <button className="pd-back-button" onClick={handleGoBack} aria-label="Go back">
// //               <i className="fa fa-arrow-circle-left" aria-hidden="true"></i>
// //             </button>
// //             <h1 className="pd-title">Global Leaderboard</h1>
// //             <Trophy className="pd-title-icon" />
// //           </div>
// //           <div className="flex items-center gap-4">
// //             <button
// //               onClick={handleRefresh}
// //               disabled={isRefreshing}
// //               className=""
// //             >
// //               <RefreshCw size={18} className={`pd-refresh-icon ${isRefreshing ? 'pd-rotating' : ''}`} />
// //             </button>
// //           </div>
// //         </div>

// //         {/* FILTERS */}
// //         <Box
// //           sx={{
// //             p: "12px 16px",
// //             borderRadius: "8px",
// //             mb: 3,
// //             display: "flex",
// //             alignItems: "center",
// //             gap: 2,
// //             flexWrap: "wrap"
// //           }}
// //         >
// //           <TextField
// //             size="small"
// //             placeholder="Search by name, department, assessment, score or rank..."
// //             value={searchQuery}
// //             onChange={(e) => setSearchQuery(e.target.value)}
// //             sx={{
// //               width: "30%",          // works correctly
// //               minWidth: 300          // prevents it from becoming too small
// //             }}
// //             InputProps={{
// //               startAdornment: (
// //                 <SearchIcon sx={{ color: "text.secondary", mr: 1 }} />
// //               )
// //             }}
// //           />


// //           {/* Exam Filter */}
// //           <TextField
// //             select
// //             size="small"
// //             label="Assessment Title"
// //             value={selectedExam}
// //             onChange={(e) => setSelectedExam(e.target.value)}
// //             sx={{ minWidth: 200 }}
// //           >
// //             <MenuItem value="all">All Assessments</MenuItem>
// //             {Array.isArray(exams) &&
// //               exams.map((exam, i) => (
// //                 <MenuItem key={i} value={exam}>
// //                   {exam}
// //                 </MenuItem>
// //               ))}
// //           </TextField>

// //           {/* Department Filter */}
// //           <TextField
// //             select
// //             size="small"
// //             label="Department"
// //             value={selectedDept}
// //             onChange={(e) => setSelectedDept(e.target.value)}
// //             sx={{ minWidth: 260 }}
// //           >
// //             <MenuItem value="all">All Departments</MenuItem>
// //             {Array.isArray(departments) &&
// //               departments.map((dept, i) => (
// //                 <MenuItem key={i} value={dept}>
// //                   {dept}
// //                 </MenuItem>
// //               ))}
// //           </TextField>

// //           {/* Search */}

// //         </Box>

// //         {/* TABLE */}
// //         <div className="pd-table-container">
// //           {loading ? (
// //             <div className="pd-table-loading">
// //               <div className="pd-table-loading-animation">
// //                 <img
// //                   className="pd-table-loading-video"
// //                   src="/images/breath1.gif"
// //                   alt="Loading..."
// //                 />
// //                 <p>Loading leaderboard...</p>
// //               </div>
// //             </div>
// //           ) : filteredData.length === 0 ? (
// //             <div
// //               className="pd-no-data"
// //               style={{ padding: '40px 0', textAlign: 'center', color: '#888' }}
// //             >
// //               {searchQuery || selectedDept !== 'all' || selectedExam !== 'all'
// //                 ? 'No results found for the selected filters'
// //                 : 'No leaderboard data available'}
// //             </div>
// //           ) : (
// //             <div className="pd-table-wrapper">
// //               <table className="pd-table">
// //                 <thead>
// //                   <tr>
// //                     <th style={{ width: '80px' }}>Rank</th>
// //                     <th style={{ width: '180px' }}>Name</th>
// //                     <th style={{ width: '150px' }}>Department</th>
// //                     <th style={{ width: '200px' }}>Assessment</th>
// //                     <th style={{ width: '100px' }} className="pd-numeric">
// //                       Score
// //                     </th>
// //                   </tr>
// //                 </thead>
// //                 <tbody>
// //                   {filteredData.map((item, idx) => (
// //                     <tr
// //                       key={`${item.id || item.name}-${item.exam}-${item.rank}-${idx}`}
// //                       className="pd-row"
// //                       onClick={() => handleRowClick(item)}
// //                       style={{ cursor: 'pointer' }}
// //                     >
// //                       <td>
// //                         <span
// //                           className={`pd-badge ${item.rank <= 3 ? 'pd-badge-success' : 'pd-badge-info'
// //                             }`}
// //                         >
// //                           #{item.rank || idx + 1}
// //                         </span>
// //                       </td>
// //                       <td>{item.name || 'Unknown'}</td>
// //                       <td>{item.dept || 'Unknown Department'}</td>
// //                       <td>{item.exam || 'Unknown Exam'}</td>
// //                       <td className="pd-numeric">
// //                         <strong
// //                           style={{
// //                             color:
// //                               item.score >= 80
// //                                 ? '#059669'
// //                                 : item.score >= 60
// //                                   ? '#d97706'
// //                                   : '#dc2626',
// //                           }}
// //                         >
// //                           {item.score || 0}%
// //                         </strong>
// //                       </td>
// //                     </tr>
// //                   ))}
// //                 </tbody>
// //               </table>
// //             </div>
// //           )}

// //           {/* PAGINATION AREA */}
// //           <div
// //             className="pd-pagination-area"
// //             style={{
// //               minHeight: '80px',
// //               marginTop: '20px',
// //               padding: '16px 0',
// //               borderTop: '1px solid #eee',
// //               backgroundColor: '#fafafa',
// //               borderRadius: '0 0 8px 8px',
// //             }}
// //           >
// //             {!loading && filteredData.length > 0 && estimatedTotalPages > 1 && (
// //               <div
// //                 className="pd-pagination"
// //                 style={{
// //                   display: 'flex',
// //                   justifyContent: 'center',
// //                   alignItems: 'center',
// //                   gap: '8px',
// //                   flexWrap: 'wrap',
// //                 }}
// //               >
// //                 <button
// //                   className="btn-negative"
// //                   disabled={currentPage === 1}
// //                   onClick={() => handlePageChange(currentPage - 1)}
// //                 >
// //                   Previous
// //                 </button>

// //                 <div className="pd-page-numbers" style={{ display: 'flex', gap: '6px' }}>
// //                   {pageNumbers.map((num) => (
// //                     <button
// //                       key={num}
// //                       className={`pg-type-btn ${currentPage === num ? 'active' : ''}`}
// //                       onClick={() => handlePageChange(num)}
// //                     >
// //                       {num}
// //                     </button>
// //                   ))}
// //                 </div>

// //                 <button
// //                   className="btn-negative"
// //                   disabled={currentPage >= estimatedTotalPages || !hasMore}
// //                   onClick={() => handlePageChange(currentPage + 1)}
// //                 >
// //                   Next
// //                 </button>
// //               </div>
// //             )}

// //             {/* {!loading && filteredData.length === 0 && (
// //       <div
// //         style={{
// //           textAlign: 'center',
// //           color: '#888',
// //           fontSize: '15px',
// //           padding: '20px 0',
// //         }}
// //       >
// //         No leaderboard data available
// //       </div>
// //     )} */}
// //           </div>
// //         </div>

// //       </div>

// //       <PerformerDetailModal
// //         open={modalOpen}
// //         performer={selectedPerformer}
// //         onClose={() => setModalOpen(false)}
// //       />
// //     </>
// //   );
// // }












// // // src/components/dashboard/LeaderboardTab.jsx
// // import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
// // import { Globe, RefreshCw, FileText, Trophy } from 'lucide-react';
// // import axios from 'axios';
// // import { useOutletContext, useNavigate } from 'react-router-dom';
// // import PerformerDetailModal from './modals/PerformerDetailModal';
// // import './OverviewTab.css';
// // import { Box, TextField, Tooltip, IconButton } from "@mui/material";
// // import SearchIcon from "@mui/icons-material/Search";
// // import CloseIcon from "@mui/icons-material/Close";

// // // Syncfusion QueryBuilder
// // import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
// // import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

// // // Syncfusion CSS (ensure these are imported once in your app)
// // import '@syncfusion/ej2-base/styles/material.css';
// // import '@syncfusion/ej2-buttons/styles/material.css';
// // import '@syncfusion/ej2-popups/styles/material.css';
// // import '@syncfusion/ej2-splitbuttons/styles/material.css';
// // import '@syncfusion/ej2-inputs/styles/material.css';
// // import '@syncfusion/ej2-lists/styles/material.css';
// // import '@syncfusion/ej2-dropdowns/styles/material.css';
// // import '@syncfusion/ej2-calendars/styles/material.css';
// // import '@syncfusion/ej2-navigations/styles/material.css';
// // import '@syncfusion/ej2-querybuilder/styles/material.css';

// // const rowsPerPage = 10;

// // // Debounce utility
// // const debounce = (func, delay) => {
// //   let timer;
// //   return (...args) => {
// //     clearTimeout(timer);
// //     timer = setTimeout(() => func(...args), delay);
// //   };
// // };

// // export default function LeaderboardTab() {
// //   const userRole = sessionStorage.getItem("user_role");
// //   const navigate = useNavigate();
// //   const [data, setData] = useState([]);
// //   const [exams, setExams] = useState([]);        // may still be used for other purposes
// //   const [departments, setDepartments] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [isRefreshing, setIsRefreshing] = useState(false);
// //   const [searchQuery, setSearchQuery] = useState('');
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [hasMore, setHasMore] = useState(false);
// //   const [totalItems, setTotalItems] = useState(0);
// //   const [modalOpen, setModalOpen] = useState(false);
// //   const [selectedPerformer, setSelectedPerformer] = useState(null);
// //   const [estimatedTotalPages, setEstimatedTotalPages] = useState(1);

// //   // Filter states
// //   const [showFilters, setShowFilters] = useState(false);
// //   const [filterRule, setFilterRule] = useState(null); // applied rule

// //   // Refs for uncontrolled QueryBuilder
// //   const qbRef = useRef(null);
// //   const currentRuleRef = useRef(null);

// //   // ================= FETCH DATA =================
// //   const fetchData = useCallback(
// //     async (rule = null, search = '', page = currentPage) => {
// //       console.log('🚀 fetchData called for leaderboard', {
// //         userRole,
// //         currentPage: page,
// //         rule,
// //         search,
// //       });

// //       if (!userRole) {
// //         console.warn('⛔ userRole not ready, skipping fetch');
// //         return;
// //       }

// //       if (isRefreshing) {
// //         console.warn('⛔ Already refreshing, skipping fetch');
// //         return;
// //       }

// //       setIsRefreshing(true);
// //       setLoading(true);

// //       try {
// //         const endpoint = '/managerdashboard/leaderboard/';

// //         const params = {
// //           page: page,
// //           page_size: rowsPerPage,
// //         };

// //         if (search.trim()) params.search = search;
// //         if (rule && rule.rules?.length) params.filters = JSON.stringify(rule);

// //         console.log('📡 API REQUEST Leaderboard:', endpoint, params);

// //         const [lbRes, examRes, deptRes] = await Promise.all([
// //           axios.get(endpoint, { params }),
// //           axios.get('/managerdashboard/exam-titles/')
// //             .then(res => res.data)
// //             .catch(err => {
// //               console.error('Error fetching exams:', err);
// //               return { exams: [] };
// //             }),
// //           axios.get('/managerdashboard/all-departments/')
// //             .then(res => res.data)
// //             .catch(err => {
// //               console.error('Error fetching departments:', err);
// //               return { departments: [] };
// //             })
// //         ]);

// //         console.log('✅ API RESPONSE Leaderboard:', lbRes.data);

// //         const responseData = lbRes.data || {};
// //         const fetchedData = Array.isArray(responseData.data) ? responseData.data : [];

// //         setData(fetchedData);

// //         // Set has_more flag
// //         const hasMoreFlag = responseData.pagination?.has_more || false;
// //         setHasMore(hasMoreFlag);

// //         // Estimate total items and pages
// //         if (responseData.pagination?.total) {
// //           const total = responseData.pagination.total;
// //           setTotalItems(total);
// //           setEstimatedTotalPages(Math.ceil(total / rowsPerPage));
// //         } else {
// //           if (hasMoreFlag) {
// //             setEstimatedTotalPages(page + 1);
// //             setTotalItems((page * rowsPerPage) + 1);
// //           } else {
// //             setEstimatedTotalPages(page);
// //             setTotalItems((page - 1) * rowsPerPage + fetchedData.length);
// //           }
// //         }

// //         setExams(Array.isArray(examRes.exams) ? examRes.exams : []);
// //         setDepartments(Array.isArray(deptRes.departments) ? deptRes.departments : []);

// //       } catch (err) {
// //         console.error('❌ Error loading leaderboard:', err);
// //         console.error('Error details:', err.response?.data || err.message);
// //         setData([]);
// //         setHasMore(false);
// //         setTotalItems(0);
// //         setEstimatedTotalPages(1);
// //       } finally {
// //         setLoading(false);
// //         setIsRefreshing(false);
// //         console.log('🏁 fetchData completed for leaderboard');
// //       }
// //     },
// //     [userRole, isRefreshing]
// //   );

// //   // Debounced fetch to avoid too many requests when typing search
// //   const debouncedFetch = useCallback(
// //     debounce((rule, search, page) => fetchData(rule, search, page), 500),
// //     [fetchData]
// //   );

// //   // Trigger fetch when dependencies change
// //   useEffect(() => {
// //     debouncedFetch(filterRule, searchQuery, currentPage);
// //   }, [currentPage, filterRule, searchQuery]);

// //   // Reset to page 1 when filterRule or search changes
// //   useEffect(() => {
// //     setCurrentPage(1);
// //   }, [filterRule, searchQuery]);

// //   // ================= FILTERED DATA (client-side search fallback) =================
// //   // Note: The backend already applies search and filters, but we keep a fallback for safety.
// //   const filteredData = useMemo(() => {
// //     if (!Array.isArray(data)) return [];

// //     if (searchQuery.trim()) {
// //       const query = searchQuery.toLowerCase().trim();
// //       return data.filter((item) => {
// //         return (
// //           (item.name || '').toLowerCase().includes(query) ||
// //           (item.dept || '').toLowerCase().includes(query) ||
// //           (item.exam || '').toLowerCase().includes(query) ||
// //           String(item.score || '').includes(query) ||
// //           String(item.rank || '').includes(query)
// //         );
// //       });
// //     }

// //     return data;
// //   }, [data, searchQuery]);

// //   // ================= QUERYBUILDER =================
// //   const queryBuilderColumns = [
// //     { field: 'name', label: 'Name', type: 'string' },
// //     { field: 'dept', label: 'Department', type: 'string' },
// //     { field: 'exam', label: 'Assessment', type: 'string' },
// //     { field: 'score', label: 'Score', type: 'number' },
// //     { field: 'rank', label: 'Rank', type: 'number' },
// //   ];

// //   const defaultRule = { condition: 'and', rules: [] };

// //   const applyFilters = () => {
// //     const rule = currentRuleRef.current || defaultRule;
// //     setFilterRule(rule);
// //     setCurrentPage(1);
// //     fetchData(rule, searchQuery, 1);
// //   };

// //   const clearAllFilters = () => {
// //     setFilterRule(null);
// //     setSearchQuery('');
// //     setCurrentPage(1);
// //     if (qbRef.current) {
// //       qbRef.current.setRules(defaultRule);
// //       currentRuleRef.current = defaultRule;
// //     }
// //     fetchData(null, '', 1);
// //   };

// //   // ================= HANDLERS =================
// //   const handleRefresh = () => {
// //     clearAllFilters();
// //   };

// //   const handleRowClick = (performer) => {
// //     setSelectedPerformer(performer);
// //     setModalOpen(true);
// //   };

// //   const handlePageChange = (newPage) => {
// //     setCurrentPage(newPage);
// //   };

// //   // Generate page numbers for pagination
// //   const getPageNumbers = () => {
// //     const pages = [];
// //     const maxPagesToShow = 5;

// //     if (estimatedTotalPages <= maxPagesToShow) {
// //       for (let i = 1; i <= estimatedTotalPages; i++) {
// //         pages.push(i);
// //       }
// //     } else {
// //       let start = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
// //       let end = Math.min(estimatedTotalPages, start + maxPagesToShow - 1);

// //       if (end - start + 1 < maxPagesToShow) {
// //         start = end - maxPagesToShow + 1;
// //       }

// //       for (let i = start; i <= end; i++) {
// //         pages.push(i);
// //       }
// //     }

// //     return pages;
// //   };

// //   const pageNumbers = getPageNumbers();

// //   const getShowingRange = () => {
// //     if (filteredData.length === 0 || totalItems === 0) return '';

// //     const start = (currentPage - 1) * rowsPerPage + 1;
// //     const end = start + filteredData.length - 1;

// //     return `Showing ${start} to ${end} of ${totalItems} entries`;
// //   };

// //   const handleGoBack = () => {
// //     if (userRole === '8') navigate('/managers/dashboard');
// //     else if (userRole === '9') navigate('/hr/dashboard');
// //     else navigate('/dashboard');
// //   };

// //   // ================= RENDER =================
// //   return (
// //     <>
// //       <div className="pd-overview-container">
// //         {/* HEADER */}
// //         <div className="pd-header">
// //           <div className="pd-title-section">
// //             <button className="pd-back-button" onClick={handleGoBack} aria-label="Go back">
// //               <i className="fa fa-arrow-circle-left" aria-hidden="true"></i>
// //             </button>
// //             <h1 className="pd-title">Global Leaderboard</h1>
// //             <Trophy className="pd-title-icon" />
// //           </div>
// //           <div className="flex items-center gap-4">
// //             <button onClick={handleRefresh} disabled={isRefreshing}>
// //               <RefreshCw size={18} className={`pd-refresh-icon ${isRefreshing ? 'pd-rotating' : ''}`} />
// //             </button>
// //           </div>
// //         </div>

// //         {/* FILTERS */}
// //         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, flexWrap: 'wrap' }}>
// //           <TextField
// //             size="small"
// //             placeholder="Search by name, department, assessment, score or rank..."
// //             value={searchQuery}
// //             onChange={(e) => setSearchQuery(e.target.value)}
// //             sx={{ width: 300 }}
// //             InputProps={{ startAdornment: <SearchIcon sx={{ color: "text.secondary", mr: 1 }} /> }}
// //           />
// //           <ButtonComponent
// //             cssClass="btn"
// //             onClick={() => {
// //               if (showFilters) {
// //                 if (qbRef.current) {
// //                   qbRef.current.setRules(defaultRule);
// //                   currentRuleRef.current = defaultRule;
// //                 }

// //                 setFilterRule(null);
// //                 setSearchQuery('');
// //                 setCurrentPage(1);

// //                 fetchData(null, '', 1);
// //               }

// //               setShowFilters(!showFilters);
// //             }}
// //           >
// //             {showFilters ? 'Close Filters' : 'Enable Filters'}
// //           </ButtonComponent>

// //         </Box>

// //         {/* SYNCFFUSION QUERYBUILDER */}
// //         {showFilters && (
// //           <div style={{ marginBottom: '20px', padding: '10px', background: '#f5f5f5', borderRadius: '8px' }}>
// //             <QueryBuilderComponent
// //               ref={qbRef}
// //               dataSource={[]}
// //               columns={queryBuilderColumns}
// //               rule={defaultRule}
// //               ruleChange={(args) => { currentRuleRef.current = args.rule; }}
// //               created={() => {
// //                 if (qbRef.current) qbRef.current.setRules(defaultRule);
// //               }}
// //               showButtons={false}
// //               summaryView={false}
// //             />
// //             <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
// //               <ButtonComponent
// //                 cssClass="btn-negative"
// //                 onClick={() => {
// //                   if (qbRef.current) {
// //                     qbRef.current.setRules(defaultRule);
// //                     currentRuleRef.current = defaultRule;
// //                   }
// //                   setFilterRule(null);
// //                   setSearchQuery('');
// //                   setCurrentPage(1);
// //                   fetchData(null, '', 1);
// //                 }}
// //               >
// //                 Clear Filters
// //               </ButtonComponent>
// //               <ButtonComponent cssClass="btn" onClick={applyFilters}>
// //                 Apply Filters
// //               </ButtonComponent>
// //             </Box>
// //           </div>
// //         )}

// //         {/* TABLE */}
// //         <div className="pd-table-container">
// //           {loading ? (
// //             <div className="pd-table-loading">
// //               <div className="pd-table-loading-animation">
// //                 <img
// //                   className="pd-table-loading-video"
// //                   src="/images/breath1.gif"
// //                   alt="Loading..."
// //                 />
// //                 <p>Loading leaderboard...</p>
// //               </div>
// //             </div>
// //           ) : filteredData.length === 0 ? (
// //             <div className="pd-no-data" style={{ padding: '40px 0', textAlign: 'center', color: '#888' }}>
// //               {searchQuery || filterRule?.rules?.length > 0
// //                 ? 'No results found for the selected filters'
// //                 : 'No leaderboard data available'}
// //             </div>
// //           ) : (
// //             <div className="pd-table-wrapper">
// //               <table className="pd-table">
// //                 <thead>
// //                   <tr>
// //                     <th style={{ width: '80px' }}>S.No</th>
// //                     <th style={{ width: '180px' }}>Name</th>
// //                     <th style={{ width: '150px' }}>Department</th>
// //                     <th style={{ width: '200px' }}>Assessment</th>
// //                     <th style={{ width: '100px' }} className="pd-numeric">Score</th>
// //                   </tr>
// //                 </thead>
// //                 <tbody>
// //                   {filteredData.map((item, idx) => (
// //                     <tr
// //                       key={`${item.id || item.name}-${item.exam}-${item.rank}-${idx}`}
// //                       className="pd-row"
// //                       onClick={() => handleRowClick(item)}
// //                       style={{ cursor: 'pointer' }}
// //                     >
// //                       <td>
// //                         <span
// //                           className={`pd-badge ${item.rank <= 3 ? 'pd-badge-success' : 'pd-badge-info'
// //                             }`}
// //                         >
// //                           {item.rank || idx + 1}
// //                         </span>
// //                       </td>
// //                       <td>{item.name || 'Unknown'}</td>
// //                       <td>{item.dept || 'Unknown Department'}</td>
// //                       <td>{item.exam || 'Unknown Exam'}</td>
// //                       <td className="pd-numeric">
// //                         <strong
// //                           style={{
// //                             color:
// //                               item.score >= 80
// //                                 ? '#059669'
// //                                 : item.score >= 60
// //                                   ? '#d97706'
// //                                   : '#dc2626',
// //                           }}
// //                         >
// //                           {item.score || 0}%
// //                         </strong>
// //                       </td>
// //                     </tr>
// //                   ))}
// //                 </tbody>
// //               </table>
// //             </div>
// //           )}

// //           {/* PAGINATION */}
// //           {!loading && filteredData.length > 0 && estimatedTotalPages > 1 && (
// //             <div className="pd-pagination" style={{ marginTop: '20px' }}>
// //               <button
// //                 className="btn-negative"
// //                 disabled={currentPage === 1}
// //                 onClick={() => handlePageChange(currentPage - 1)}
// //               >
// //                 Previous
// //               </button>
// //               <div className="pd-page-numbers">
// //                 {pageNumbers.map((num) => (
// //                   <button
// //                     key={num}
// //                     className={`pg-type-btn ${currentPage === num ? 'active' : ''}`}
// //                     onClick={() => handlePageChange(num)}
// //                   >
// //                     {num}
// //                   </button>
// //                 ))}
// //               </div>
// //               <button
// //                 className="btn-negative"
// //                 disabled={currentPage >= estimatedTotalPages || !hasMore}
// //                 onClick={() => handlePageChange(currentPage + 1)}
// //               >
// //                 Next
// //               </button>
// //             </div>
// //           )}
// //         </div>
// //       </div>

// //       <PerformerDetailModal
// //         open={modalOpen}
// //         performer={selectedPerformer}
// //         onClose={() => setModalOpen(false)}
// //       />
// //     </>
// //   );
// // }


// // src/components/dashboard/LeaderboardTab.jsx
// import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
// import { Globe, RefreshCw, FileText, Trophy } from 'lucide-react';
// import axios from 'axios';
// import { useOutletContext, useNavigate } from 'react-router-dom';
// import PerformerDetailModal from './modals/PerformerDetailModal';
// import './OverviewTab.css';
// import { Box, TextField, Tooltip, IconButton } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import CloseIcon from "@mui/icons-material/Close";

// // Syncfusion QueryBuilder
// import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
// import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

// // Syncfusion CSS (ensure these are imported once in your app)
// import '@syncfusion/ej2-base/styles/material.css';
// import '@syncfusion/ej2-buttons/styles/material.css';
// import '@syncfusion/ej2-popups/styles/material.css';
// import '@syncfusion/ej2-splitbuttons/styles/material.css';
// import '@syncfusion/ej2-inputs/styles/material.css';
// import '@syncfusion/ej2-lists/styles/material.css';
// import '@syncfusion/ej2-dropdowns/styles/material.css';
// import '@syncfusion/ej2-calendars/styles/material.css';
// import '@syncfusion/ej2-navigations/styles/material.css';
// import '@syncfusion/ej2-querybuilder/styles/material.css';

// const rowsPerPage = 10;

// // Debounce utility
// const debounce = (func, delay) => {
//   let timer;
//   return (...args) => {
//     clearTimeout(timer);
//     timer = setTimeout(() => func(...args), delay);
//   };
// };

// export default function LeaderboardTab() {
//   const userRole = sessionStorage.getItem("user_role");
//   const navigate = useNavigate();
//   const [data, setData] = useState([]);
//   const [exams, setExams] = useState([]);        // may still be used for other purposes
//   const [departments, setDepartments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [isRefreshing, setIsRefreshing] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [hasMore, setHasMore] = useState(false);
//   const [totalItems, setTotalItems] = useState(0);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedPerformer, setSelectedPerformer] = useState(null);
//   const [estimatedTotalPages, setEstimatedTotalPages] = useState(1);

//   // Filter states
//   const [showFilters, setShowFilters] = useState(false);
//   const [filterRule, setFilterRule] = useState(null); // applied rule

//   // Refs for uncontrolled QueryBuilder
//   const qbRef = useRef(null);
//   const currentRuleRef = useRef(null);

//   // ================= FETCH DATA =================
//   const fetchData = useCallback(
//     async (rule = null, search = '', page = currentPage) => {
//       console.log('🚀 fetchData called for leaderboard', {
//         userRole,
//         currentPage: page,
//         rule,
//         search,
//       });

//       if (!userRole) {
//         console.warn('⛔ userRole not ready, skipping fetch');
//         return;
//       }

//       if (isRefreshing) {
//         console.warn('⛔ Already refreshing, skipping fetch');
//         return;
//       }

//       setIsRefreshing(true);
//       setLoading(true);

//       try {
//         const endpoint = '/managerdashboard/leaderboard/';

//         const params = {
//           page: page,
//           page_size: rowsPerPage,
//         };

//         if (search.trim()) params.search = search;
//         if (rule && rule.rules?.length) params.filters = JSON.stringify(rule);

//         console.log('📡 API REQUEST Leaderboard:', endpoint, params);

//         const [lbRes, examRes, deptRes] = await Promise.all([
//           axios.get(endpoint, { params }),
//           axios.get('/managerdashboard/exam-titles/')
//             .then(res => res.data)
//             .catch(err => {
//               console.error('Error fetching exams:', err);
//               return { exams: [] };
//             }),
//           axios.get('/managerdashboard/all-departments/')
//             .then(res => res.data)
//             .catch(err => {
//               console.error('Error fetching departments:', err);
//               return { departments: [] };
//             })
//         ]);

//         console.log('✅ API RESPONSE Leaderboard:', lbRes.data);

//         const responseData = lbRes.data || {};
//         const fetchedData = Array.isArray(responseData.data) ? responseData.data : [];

//         setData(fetchedData);

//         // Set has_more flag
//         const hasMoreFlag = responseData.pagination?.has_more || false;
//         setHasMore(hasMoreFlag);

//         // Estimate total items and pages
//         if (responseData.pagination?.total) {
//           const total = responseData.pagination.total;
//           setTotalItems(total);
//           setEstimatedTotalPages(Math.ceil(total / rowsPerPage));
//         } else {
//           if (hasMoreFlag) {
//             setEstimatedTotalPages(page + 1);
//             setTotalItems((page * rowsPerPage) + 1);
//           } else {
//             setEstimatedTotalPages(page);
//             setTotalItems((page - 1) * rowsPerPage + fetchedData.length);
//           }
//         }

//         setExams(Array.isArray(examRes.exams) ? examRes.exams : []);
//         setDepartments(Array.isArray(deptRes.departments) ? deptRes.departments : []);

//       } catch (err) {
//         console.error('❌ Error loading leaderboard:', err);
//         console.error('Error details:', err.response?.data || err.message);
//         setData([]);
//         setHasMore(false);
//         setTotalItems(0);
//         setEstimatedTotalPages(1);
//       } finally {
//         setLoading(false);
//         setIsRefreshing(false);
//         console.log('🏁 fetchData completed for leaderboard');
//       }
//     },
//     [userRole, isRefreshing]
//   );

//   // Debounced fetch to avoid too many requests when typing search
//   const debouncedFetch = useCallback(
//     debounce((rule, search, page) => fetchData(rule, search, page), 500),
//     [fetchData]
//   );

//   // Trigger fetch when dependencies change
//   useEffect(() => {
//     debouncedFetch(filterRule, searchQuery, currentPage);
//   }, [currentPage, filterRule, searchQuery]);

//   // Reset to page 1 when filterRule or search changes
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [filterRule, searchQuery]);

//   // ================= FILTERED DATA (client-side search fallback) =================
//   // Note: The backend already applies search and filters, but we keep a fallback for safety.
//   const filteredData = useMemo(() => {
//     if (!Array.isArray(data)) return [];

//     if (searchQuery.trim()) {
//       const query = searchQuery.toLowerCase().trim().replace('%', '');
//       return data.filter((item) => {
//         return (
//           (item.name || '').toLowerCase().includes(query) ||
//           (item.dept || '').toLowerCase().includes(query) ||
//           (item.exam || '').toLowerCase().includes(query) ||
//           `${item.score}%`.toLowerCase().includes(query) ||
//           String(item.rank || '').includes(query)
//         );
//       });
//     }

//     return data;
//   }, [data, searchQuery]);

//   // ================= QUERYBUILDER =================
//   const queryBuilderColumns = [
//     { field: 'rank', label: 'S.No', type: 'number' },
//     { field: 'name', label: 'Name', type: 'string' },
//     { field: 'dept', label: 'Department', type: 'string' },
//     { field: 'exam', label: 'Assessment Title', type: 'string' },
//     { field: 'score', label: 'Score', type: 'number' },
    
//   ];

//   const defaultRule = { condition: 'and', rules: [] };

//   const applyFilters = () => {
//     const rule = currentRuleRef.current || defaultRule;
//     setFilterRule(rule);
//     setCurrentPage(1);
//     fetchData(rule, searchQuery, 1);
//   };

//   const clearAllFilters = () => {
//     setFilterRule(null);
//     setSearchQuery('');
//     setCurrentPage(1);
//     if (qbRef.current) {
//       qbRef.current.setRules(defaultRule);
//       currentRuleRef.current = defaultRule;
//     }
//     fetchData(null, '', 1);
//   };

//   // ================= HANDLERS =================
//   const handleRefresh = () => {
//     clearAllFilters();
//   };

//   const handleRowClick = (performer) => {
//     setSelectedPerformer(performer);
//     setModalOpen(true);
//   };

//   const handlePageChange = (newPage) => {
//     setCurrentPage(newPage);
//   };

//   // Generate page numbers for pagination
//   // const getPageNumbers = () => {
//   //   const pages = [];
//   //   const maxPagesToShow = 5;

//   //   if (estimatedTotalPages <= maxPagesToShow) {
//   //     for (let i = 1; i <= estimatedTotalPages; i++) {
//   //       pages.push(i);
//   //     }
//   //   } else {
//   //     let start = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
//   //     let end = Math.min(estimatedTotalPages, start + maxPagesToShow - 1);

//   //     if (end - start + 1 < maxPagesToShow) {
//   //       start = end - maxPagesToShow + 1;
//   //     }

//   //     for (let i = start; i <= end; i++) {
//   //       pages.push(i);
//   //     }
//   //   }

//   //   return pages;
//   // };

//   //const pageNumbers = getPageNumbers();

//   const getShowingRange = () => {
//     if (filteredData.length === 0 || totalItems === 0) return '';

//     const start = (currentPage - 1) * rowsPerPage + 1;
//     const end = start + filteredData.length - 1;

//     return `Showing ${start} to ${end} of ${totalItems} entries`;
//   };

//   const handleGoBack = () => {
//     if (userRole === '8') navigate('/managers/dashboard');
//     else if (userRole === '9') navigate('/hr/dashboard');
//     else navigate('/dashboard');
//   };

//   // Get empty state message
//   const getEmptyStateMessage = () => {
//     if (searchQuery || filterRule?.rules?.length > 0) {
//       return 'No results found for the selected filters';
//     }
//     return 'No leaderboard data available';
//   };

//   // ================= RENDER =================
//   return (
//     <>
//       <div className="pd-overview-container">
//         {/* HEADER */}
//         <div className="pd-header">
//           <div className="pd-title-section">
//             <button className="pd-back-button" onClick={handleGoBack} aria-label="Go back">
//               <i className="fa fa-arrow-circle-left" aria-hidden="true"></i>
//             </button>
//             <h1 className="pd-title">Global Leaderboard</h1>
//             <Trophy className="pd-title-icon" />
//           </div>
//           <div className="flex items-center gap-4">
//             <button onClick={handleRefresh} disabled={isRefreshing}>
//               <RefreshCw size={18} className={`pd-refresh-icon ${isRefreshing ? 'pd-rotating' : ''}`} />
//             </button>
//           </div>
//         </div>

//         {/* FILTERS */}
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, flexWrap: 'wrap' }}>
//           <TextField
//             size="small"
//             placeholder="Search by Name, Department, Assessment Title, Score..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             sx={{ width: 300 }}
//             InputProps={{ startAdornment: <SearchIcon sx={{ color: "text.secondary", mr: 1 }} /> }}
//           />
//           <ButtonComponent
//             cssClass="btn"
//             onClick={() => {
//               if (showFilters) {
//                 if (qbRef.current) {
//                   qbRef.current.setRules(defaultRule);
//                   currentRuleRef.current = defaultRule;
//                 }

//                 setFilterRule(null);
//                 setSearchQuery('');
//                 setCurrentPage(1);

//                 fetchData(null, '', 1);
//               }

//               setShowFilters(!showFilters);
//             }}
//           >
//             {showFilters ? 'Close Filters' : 'Enable Filters'}
//           </ButtonComponent>

//         </Box>

//         {/* SYNCFFUSION QUERYBUILDER */}
//         {showFilters && (
//           <div style={{ marginBottom: '20px', padding: '10px', background: '#f5f5f5', borderRadius: '8px' }}>
//             <QueryBuilderComponent
//               ref={qbRef}
//               dataSource={[]}
//               columns={queryBuilderColumns}
//               rule={defaultRule}
//               ruleChange={(args) => { currentRuleRef.current = args.rule; }}
//               created={() => {
//                 if (qbRef.current) qbRef.current.setRules(defaultRule);
//               }}
//               showButtons={false}
//               summaryView={false}
//             />
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
//               <ButtonComponent
//                 cssClass="btn-negative"
//                 onClick={() => {
//                   if (qbRef.current) {
//                     qbRef.current.setRules(defaultRule);
//                     currentRuleRef.current = defaultRule;
//                   }
//                   setFilterRule(null);
//                   setSearchQuery('');
//                   setCurrentPage(1);
//                   fetchData(null, '', 1);
//                 }}
//               >
//                 Clear Filters
//               </ButtonComponent>
//               <ButtonComponent cssClass="btn" onClick={applyFilters}>
//                 Apply Filters
//               </ButtonComponent>
//             </Box>
//           </div>
//         )}

//         {/* TABLE */}
//         <div className="pd-table-container">
//           {loading ? (
//             <div className="pd-table-loading">
//               <div className="pd-table-loading-animation">
//                 <img
//                   className="pd-table-loading-video"
//                   src="/images/breath1.gif"
//                   alt="Loading..."
//                 />
//                 <p>Loading leaderboard...</p>
//               </div>
//             </div>
//           ) : (
//             <div className="pd-table-wrapper">
//               <table className="pd-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: '80px' }}>S.No</th>
//                     <th style={{ width: '180px' }}>Name</th>
//                     <th style={{ width: '150px' }}>Department</th>
//                     <th style={{ width: '200px' }}>Assessment Title</th>
//                     <th style={{ width: '100px' }} className="pd-numeric">Score</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredData.length === 0 ? (
//                     <tr>
//                       <td colSpan="5" style={{ textAlign: 'center', padding: '60px 20px' }}>
//                         <div style={{ 
//                           display: 'flex', 
//                           flexDirection: 'column', 
//                           alignItems: 'center', 
//                           gap: '12px' 
//                         }}
//                         >
//                           <Trophy size={48} style={{ opacity: 0.3, color: '#888' }} />
//                           <div style={{ fontSize: '16px', color: '#666' }}>
//                             {getEmptyStateMessage()}
//                           </div>
//                           {(searchQuery || filterRule?.rules?.length > 0) && (
//                             <div style={{ fontSize: '14px', color: '#999' }}>
//                               Try adjusting your search or filters
//                             </div>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                   ) : (
//                     filteredData.map((item, idx) => (
//                       <tr
//                         key={`${item.id || item.name}-${item.exam}-${item.rank}-${idx}`}
//                         className="pd-row"
//                         onClick={() => handleRowClick(item)}
//                         style={{ cursor: 'pointer' }}
//                       >
//                         <td >
//                           {/* <span
//                             className={`pd-badge ${item.rank <= 3 ? 'pd-badge-success' : 'pd-badge-info'}`}
//                           >
//                             {item.rank || idx + 1}
//                           </span> */}
//                            {item.rank || idx + 1}
//                         </td>
//                         <td>{item.name || 'Unknown'}</td>
//                         <td>{item.dept || 'Unknown Department'}</td>
//                         <td>{item.exam || 'Unknown Exam'}</td>
//                         <td className="pd-numeric">
//                           <strong
//                             style={{
//                               color:
//                                 item.score >= 80
//                                   ? '#059669'
//                                   : item.score >= 60
//                                     ? '#d97706'
//                                     : '#dc2626',
//                             }}
//                           >
//                             {item.score || 0}%
//                           </strong>
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           )}

//           {/* PAGINATION */}
//           {/* {!loading && filteredData.length > 0 && estimatedTotalPages > 1 && (
//             <div className="pd-pagination" style={{ marginTop: '20px' }}>
//               <button
//                 className="btn-negative"
//                 disabled={currentPage === 1}
//                 onClick={() => handlePageChange(currentPage - 1)}
//               >
//                 Previous
//               </button>
//               <div className="pd-page-numbers">
//                 {pageNumbers.map((num) => (
//                   <button
//                     key={num}
//                     className={`pg-type-btn ${currentPage === num ? 'active' : ''}`}
//                     onClick={() => handlePageChange(num)}
//                   >
//                     {num}
//                   </button>
//                 ))}
//               </div>
//               <button
//                 className="btn-negative"
//                 disabled={currentPage >= estimatedTotalPages || !hasMore}
//                 onClick={() => handlePageChange(currentPage + 1)}
//               >
//                 Next
//               </button>
//             </div>
//           )} */}
//           {/* PAGINATION */}
// {/* PAGINATION */}
// {!loading && estimatedTotalPages > 1 && (
//   <div
//     style={{
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       gap: "10px",
//       marginTop: "20px",
//       flexWrap: "wrap"
//     }}
//   >
//     {/* Previous */}
//     <button
//       className="btn-negative"
//       disabled={currentPage === 1}
//       onClick={() => handlePageChange(currentPage - 1)}
//     >
//       Previous
//     </button>

//     {/* Page Numbers */}
//     <div
//       style={{
//         display: "flex",
//         alignItems: "center",
//         gap: "6px"
//       }}
//     >
//       {Array.from(
//         { length: estimatedTotalPages },
//         (_, i) => i + 1
//       )
//         .filter((num) => {
//           return (
//             num === 1 ||
//             num === estimatedTotalPages ||
//             (num >= currentPage - 1 &&
//               num <= currentPage + 1)
//           );
//         })
//         .map((num, index, arr) => {
//           const prev = arr[index - 1];

//           return (
//             <React.Fragment key={num}>
//               {prev && num - prev > 1 && (
//                 <span style={{ padding: "0 4px" }}>
//                   ...
//                 </span>
//               )}

//               <button
//                 onClick={() => handlePageChange(num)}
//                 className={`pg-type-btn ${
//                   currentPage === num ? "active" : ""
//                 }`}
//               >
//                 {num}
//               </button>
//             </React.Fragment>
//           );
//         })}
//     </div>

//     {/* Next */}
//     <button
//       className="btn-negative"
//       disabled={
//         currentPage === estimatedTotalPages || !hasMore
//       }
//       onClick={() => handlePageChange(currentPage + 1)}
//     >
//       Next
//     </button>
//   </div>
// )}
//         </div>
//       </div>

//       <PerformerDetailModal
//         open={modalOpen}
//         performer={selectedPerformer}
//         onClose={() => setModalOpen(false)}
//       />
//     </>
//   );
// }










import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { Globe, RefreshCw, FileText, Trophy } from 'lucide-react';
import axios from 'axios';
import { useOutletContext, useNavigate } from 'react-router-dom';
import PerformerDetailModal from './modals/PerformerDetailModal';
import './OverviewTab.css';
import { Box, TextField, Tooltip, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
 
// Syncfusion QueryBuilder
import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
 
// Syncfusion CSS (ensure these are imported once in your app)
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-lists/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-calendars/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-querybuilder/styles/material.css';
 
const rowsPerPage = 10;
 
// Debounce utility
const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
};
 
export default function LeaderboardTab() {
  const userRole = sessionStorage.getItem("user_role");
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [exams, setExams] = useState([]);        // may still be used for other purposes
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPerformer, setSelectedPerformer] = useState(null);
  const [estimatedTotalPages, setEstimatedTotalPages] = useState(1);
 
  // Filter states
  const [showFilters, setShowFilters] = useState(false);
  const [filterRule, setFilterRule] = useState(null); // applied rule
 
  // Refs for uncontrolled QueryBuilder
  const qbRef = useRef(null);
  const currentRuleRef = useRef(null);
 
  // ================= FETCH DATA =================
  const fetchData = useCallback(
    async (rule = null, search = '', page = currentPage) => {
      console.log('🚀 fetchData called for leaderboard', {
        userRole,
        currentPage: page,
        rule,
        search,
      });
 
      if (!userRole) {
        console.warn('⛔ userRole not ready, skipping fetch');
        return;
      }
 
      if (isRefreshing) {
        console.warn('⛔ Already refreshing, skipping fetch');
        return;
      }
 
      setIsRefreshing(true);
      setLoading(true);
 
      try {
        const endpoint = '/managerdashboard/leaderboard/';
 
        const params = {
          page: page,
          page_size: rowsPerPage,
        };
 
        if (search.trim()) params.search = search;
        if (rule && rule.rules?.length) params.filters = JSON.stringify(rule);
 
        console.log('📡 API REQUEST Leaderboard:', endpoint, params);
 
        const [lbRes, examRes, deptRes] = await Promise.all([
          axios.get(endpoint, { params }),
          axios.get('/managerdashboard/exam-titles/')
            .then(res => res.data)
            .catch(err => {
              console.error('Error fetching exams:', err);
              return { exams: [] };
            }),
          axios.get('/managerdashboard/all-departments/')
            .then(res => res.data)
            .catch(err => {
              console.error('Error fetching departments:', err);
              return { departments: [] };
            })
        ]);
 
        console.log('✅ API RESPONSE Leaderboard:', lbRes.data);
 
        const responseData = lbRes.data || {};
        const fetchedData = Array.isArray(responseData.data) ? responseData.data : [];
 
        setData(fetchedData);
 
        // Set has_more flag
        const hasMoreFlag = responseData.pagination?.has_more || false;
        setHasMore(hasMoreFlag);
 
        // Estimate total items and pages
        if (responseData.pagination?.total) {
          const total = responseData.pagination.total;
          setTotalItems(total);
          setEstimatedTotalPages(Math.ceil(total / rowsPerPage));
        } else {
          if (hasMoreFlag) {
            setEstimatedTotalPages(page + 1);
            setTotalItems((page * rowsPerPage) + 1);
          } else {
            setEstimatedTotalPages(page);
            setTotalItems((page - 1) * rowsPerPage + fetchedData.length);
          }
        }
 
        setExams(Array.isArray(examRes.exams) ? examRes.exams : []);
        setDepartments(Array.isArray(deptRes.departments) ? deptRes.departments : []);
 
      } catch (err) {
        console.error('❌ Error loading leaderboard:', err);
        console.error('Error details:', err.response?.data || err.message);
        setData([]);
        setHasMore(false);
        setTotalItems(0);
        setEstimatedTotalPages(1);
      } finally {
        setLoading(false);
        setIsRefreshing(false);
        console.log('🏁 fetchData completed for leaderboard');
      }
    },
    [userRole, isRefreshing]
  );
 
  // Debounced fetch to avoid too many requests when typing search
  const debouncedFetch = useCallback(
    debounce((rule, search, page) => fetchData(rule, search, page), 500),
    [fetchData]
  );
 
  // Trigger fetch when dependencies change
  useEffect(() => {
    debouncedFetch(filterRule, searchQuery, currentPage);
  }, [currentPage, filterRule, searchQuery]);
 
  // Reset to page 1 when filterRule or search changes
  useEffect(() => {
    setCurrentPage(1);
  }, [filterRule, searchQuery]);
 
  // ================= FILTERED DATA (client-side search fallback) =================
  // Note: The backend already applies search and filters, but we keep a fallback for safety.
  const filteredData = useMemo(() => {
    if (!Array.isArray(data)) return [];
 
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim().replace('%', '');
      return data.filter((item) => {
        return (
          (item.name || '').toLowerCase().includes(query) ||
          (item.dept || '').toLowerCase().includes(query) ||
          (item.exam || '').toLowerCase().includes(query) ||
          `${item.score}%`.toLowerCase().includes(query) ||
          String(item.rank || '').includes(query)
        );
      });
    }
 
    return data;
  }, [data, searchQuery]);
 
  // ================= QUERYBUILDER =================
  const queryBuilderColumns = [
    // { field: 'rank', label: 'S.No', type: 'number' },
    { field: 'name', label: 'Name', type: 'string' },
    { field: 'dept', label: 'Department', type: 'string' },
    { field: 'exam', label: 'Assessment Title', type: 'string' },
    { field: 'score', label: 'Score', type: 'number' },
 
  ];
 
  const defaultRule = { condition: 'and', rules: [] };
 
  const applyFilters = () => {
    const rule = currentRuleRef.current || defaultRule;
    setFilterRule(rule);
    setCurrentPage(1);
    fetchData(rule, searchQuery, 1);
  };
 
  const clearAllFilters = () => {
    setFilterRule(null);
    setSearchQuery('');
    setCurrentPage(1);
    if (qbRef.current) {
      qbRef.current.setRules(defaultRule);
      currentRuleRef.current = defaultRule;
    }
    fetchData(null, '', 1);
  };
 
  // ================= HANDLERS =================
  const handleRefresh = () => {
    clearAllFilters();
  };
 
  const handleRowClick = (performer) => {
    setSelectedPerformer(performer);
    setModalOpen(true);
  };
 
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
 
  // Generate page numbers for pagination
  // const getPageNumbers = () => {
  //   const pages = [];
  //   const maxPagesToShow = 5;
 
  //   if (estimatedTotalPages <= maxPagesToShow) {
  //     for (let i = 1; i <= estimatedTotalPages; i++) {
  //       pages.push(i);
  //     }
  //   } else {
  //     let start = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
  //     let end = Math.min(estimatedTotalPages, start + maxPagesToShow - 1);
 
  //     if (end - start + 1 < maxPagesToShow) {
  //       start = end - maxPagesToShow + 1;
  //     }
 
  //     for (let i = start; i <= end; i++) {
  //       pages.push(i);
  //     }
  //   }
 
  //   return pages;
  // };
 
  //const pageNumbers = getPageNumbers();
 
  const getShowingRange = () => {
    if (filteredData.length === 0 || totalItems === 0) return '';
 
    const start = (currentPage - 1) * rowsPerPage + 1;
    const end = start + filteredData.length - 1;
 
    return `Showing ${start} to ${end} of ${totalItems} entries`;
  };
 
  const handleGoBack = () => {
    if (userRole === '8') navigate('/managers/dashboard');
    else if (userRole === '9') navigate('/hr/dashboard');
    else navigate('/dashboard');
  };
 
  // Get empty state message
  const getEmptyStateMessage = () => {
    if (searchQuery || filterRule?.rules?.length > 0) {
      return 'No results found for the selected filters';
    }
    return 'No leaderboard data available';
  };
 
  // ================= RENDER =================
  return (
    <>
      <div className="pd-overview-container">
        {/* HEADER */}
        <div className="pd-header">
          <div className="pd-title-section">
            <button className="pd-back-button" onClick={handleGoBack} aria-label="Go back">
              <i className="fa fa-arrow-circle-left" aria-hidden="true"></i>
            </button>
            <h1 className="pd-title">Global Leaderboard</h1>
            <Trophy className="pd-title-icon" />
          </div>
          <div className="flex items-center gap-4">
            <button onClick={handleRefresh} disabled={isRefreshing}>
              <RefreshCw size={18} className={`pd-refresh-icon ${isRefreshing ? 'pd-rotating' : ''}`} />
            </button>
          </div>
        </div>
 
        {/* FILTERS */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, width: '100%', }}>
          <TextField
            size="small"
            placeholder="Search by Name, Department, Assessment Title, Score..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{ startAdornment: <SearchIcon sx={{ color: "text.secondary", mr: 1 }} /> }}
            sx={{
              flex: 1,
              minWidth: 350,
              "& .MuiOutlinedInput-root": {
                height: "40px",
              },
            }}
          />
          <ButtonComponent
            cssClass="btn"
            style={{
              minWidth: "160px",
              whiteSpace: "nowrap",
            }}
            onClick={() => {
              if (showFilters) {
                if (qbRef.current) {
                  qbRef.current.setRules(defaultRule);
                  currentRuleRef.current = defaultRule;
                }
 
                setFilterRule(null);
                setSearchQuery('');
                setCurrentPage(1);
 
                fetchData(null, '', 1);
              }
 
              setShowFilters(!showFilters);
            }}
          >
            {showFilters ? 'Close Filters' : 'Enable Filters'}
          </ButtonComponent>
 
        </Box>
 
        {/* SYNCFFUSION QUERYBUILDER */}
        {showFilters && (
          <div style={{ marginBottom: '20px', padding: '10px', background: '#f5f5f5', borderRadius: '8px' }}>
            <QueryBuilderComponent
              ref={qbRef}
              dataSource={[]}
              columns={queryBuilderColumns}
              rule={defaultRule}
              ruleChange={(args) => { currentRuleRef.current = args.rule; }}
              created={() => {
                if (qbRef.current) qbRef.current.setRules(defaultRule);
              }}
              showButtons={false}
              summaryView={false}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
              <ButtonComponent
                cssClass="btn-negative"
                onClick={() => {
                  if (qbRef.current) {
                    qbRef.current.setRules(defaultRule);
                    currentRuleRef.current = defaultRule;
                  }
                  setFilterRule(null);
                  setSearchQuery('');
                  setCurrentPage(1);
                  fetchData(null, '', 1);
                }}
              >
                Clear Filters
              </ButtonComponent>
              <ButtonComponent cssClass="btn" onClick={applyFilters}>
                Apply Filters
              </ButtonComponent>
            </Box>
          </div>
        )}
 
        {/* TABLE */}
        <div className="pd-table-container">
          {loading ? (
            <div className="pd-table-loading">
              <div className="pd-table-loading-animation">
                <img
                  className="pd-table-loading-video"
                  src="/images/breath1.gif"
                  alt="Loading..."
                />
                <p>Loading leaderboard...</p>
              </div>
            </div>
          ) : (
            <div className="pd-table-wrapper">
              <table className="pd-table">
                <thead>
                  <tr>
                    <th style={{ width: '80px' }}>S.No</th>
                    <th style={{ width: '180px' }}>Name</th>
                    <th style={{ width: '150px' }}>Department</th>
                    <th style={{ width: '200px' }}>Assessment Title</th>
                    <th style={{ width: '100px' }} className="pd-numeric">Score</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length === 0 ? (
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center', padding: '60px 20px' }}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: '12px'
                        }}
                        >
                          <Trophy size={48} style={{ opacity: 0.3, color: '#888' }} />
                          <div style={{ fontSize: '16px', color: '#666' }}>
                            {getEmptyStateMessage()}
                          </div>
                          {(searchQuery || filterRule?.rules?.length > 0) && (
                            <div style={{ fontSize: '14px', color: '#999' }}>
                              Try adjusting your search or filters
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    filteredData.map((item, idx) => (
                      <tr
                        key={`${item.id || item.name}-${item.exam}-${item.rank}-${idx}`}
                        className="pd-row"
                        onClick={() => handleRowClick(item)}
                        style={{ cursor: 'pointer' }}
                      >
                        <td >
                          {/* <span
                            className={`pd-badge ${item.rank <= 3 ? 'pd-badge-success' : 'pd-badge-info'}`}
                          >
                            {item.rank || idx + 1}
                          </span> */}
                          {item.rank || idx + 1}
                        </td>
                        <td>{item.name || 'Unknown'}</td>
                        <td>{item.dept || 'Unknown Department'}</td>
                        <td>{item.exam || 'Unknown Exam'}</td>
                        <td className="pd-numeric">
                          <strong
                            style={{
                              color:
                                item.score >= 80
                                  ? '#059669'
                                  : item.score >= 60
                                    ? '#d97706'
                                    : '#dc2626',
                            }}
                          >
                            {item.score || 0}%
                          </strong>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
 
          {/* PAGINATION */}
          {/* {!loading && filteredData.length > 0 && estimatedTotalPages > 1 && (
            <div className="pd-pagination" style={{ marginTop: '20px' }}>
              <button
                className="btn-negative"
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                Previous
              </button>
              <div className="pd-page-numbers">
                {pageNumbers.map((num) => (
                  <button
                    key={num}
                    className={`pg-type-btn ${currentPage === num ? 'active' : ''}`}
                    onClick={() => handlePageChange(num)}
                  >
                    {num}
                  </button>
                ))}
              </div>
              <button
                className="btn-negative"
                disabled={currentPage >= estimatedTotalPages || !hasMore}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Next
              </button>
            </div>
          )} */}
          {/* PAGINATION */}
          {/* PAGINATION */}
          {!loading && estimatedTotalPages > 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                marginTop: "20px",
                flexWrap: "wrap"
              }}
            >
              {/* Previous */}
              <button
                className="btn-negative"
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                Previous
              </button>
 
              {/* Page Numbers */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px"
                }}
              >
                {Array.from(
                  { length: estimatedTotalPages },
                  (_, i) => i + 1
                )
                  .filter((num) => {
                    return (
                      num === 1 ||
                      num === estimatedTotalPages ||
                      (num >= currentPage - 1 &&
                        num <= currentPage + 1)
                    );
                  })
                  .map((num, index, arr) => {
                    const prev = arr[index - 1];
 
                    return (
                      <React.Fragment key={num}>
                        {prev && num - prev > 1 && (
                          <span style={{ padding: "0 4px" }}>
                            ...
                          </span>
                        )}
 
                        <button
                          onClick={() => handlePageChange(num)}
                          className={`pg-type-btn ${currentPage === num ? "active" : ""
                            }`}
                        >
                          {num}
                        </button>
                      </React.Fragment>
                    );
                  })}
              </div>
 
              {/* Next */}
              <button
                className="btn-negative"
                disabled={
                  currentPage === estimatedTotalPages || !hasMore
                }
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
 
      <PerformerDetailModal
        open={modalOpen}
        performer={selectedPerformer}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
}